import React from 'react';

/** Pill status badge. tone: success | warning | danger | brand | neutral. */
export default function Badge({ tone = 'neutral', className = '', children, ...rest }) {
  return (
    <span className={`ui-badge ui-badge--${tone} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
